const MAX_TEXTURE_SIZE = 2048;

const calculateTextureSizes = (givenW, givenH, maxTextureSize = MAX_TEXTURE_SIZE) => {
  const w = 1;
  const h = (w * givenH) / givenW;
  const p = Math.max(w, h);

  const scaleW = w / p;
  const scaleH = h / p;

  const width = Math.floor(scaleW * maxTextureSize);
  const height = Math.floor(scaleH * maxTextureSize);

  return [width, height];
};

export default calculateTextureSizes;
